import JourneyTelemetryExtended from "@/models/JourneyTelemetryExtended";
import {CollectionTransformer} from "@/transformers/index";
import {ExtendedRouteTransformer} from "@/transformers/ExtendedRouteTransformer";

export default class JourneyTelemetryExtendedTransformer {
    // TODO: dokończyc

    constructor(
        collectionTransformer = new CollectionTransformer(),
        extendedRouteTransformer = new ExtendedRouteTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.extendedRouteTransformer = extendedRouteTransformer
    }

    transform (data) {
        return new JourneyTelemetryExtended(
            this.collectionTransformer.transform(this.extendedRouteTransformer, data.extendedRoute),
            data.startGap,
            data.endGap,
            data.id,
            data.hardwareId,
            data.utc,
            data.previousJourneyTelemetryMetadata,
            data.startPoint,
            data.endPoint,
            data.lengthMeters,
            data.timeInSeconds,
            data.idleTimeInSeconds,
            data.maxSpeed,
            data.rootObject,
            data.exceptions,
            data.blobs,
            data.idlePoints,
            data.endOfJourneyIdlePoint,
            data.noGpsEvents,
            data.noCarSignalEvents,
            data.noTelemetryEvents,
            data.timeToLive,
            data.reprocessingDate,
            data.noGps,
            data.organizationId,
            data.fleetId,
            data.vehicleId,
            data.driverId
        )
    }
}
